/*jshint ignore:start*/

// Object.keys Polyfill
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
    Object.keys = (function() {
        'use strict';
        var hasOwnProperty = Object.prototype.hasOwnProperty,
            hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
            dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ],
            dontEnumsLength = dontEnums.length;

        return function(obj) {
            if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
                throw new TypeError('Object.keys called on non-object');
            }

            var result = [], prop, i;

            for (prop in obj) {
                if (hasOwnProperty.call(obj, prop)) {
                    result.push(prop);
                }
            }

            if (hasDontEnumBug) {
                for (i = 0; i < dontEnumsLength; i++) {
                    if (hasOwnProperty.call(obj, dontEnums[i])) {
                        result.push(dontEnums[i]);
                    }
                }
            }
            return result;
        };
    }());
}

// Object.assign Polyfill
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

/*jshint ignore:end*/

// SVG Fallback
(function(images){
    if (images.length === 0 || document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1") ) {
        return;
    }

    for (var i=0, n=images.length; i<n; i++){
        var fallback_src = images[i].getAttribute("data-fallback");
        if (images[i].getAttribute("src").match(/svgz?$/) && fallback_src) {
            images[i].setAttribute("src", fallback_src);
        }
    }

})(document.getElementsByTagName("img"));

// Passive Event Listener
window.sg_passive = false;
try{
    var options = Object.defineProperty({}, "passive", {
        get: function(){
            window.sg_passive = true;
        }
    });
    window.addEventListener("test", null, options);
}catch(err){}

var Sg_Utils = {

    /**
     * This callback type is to iterate over forEach functions.
     *
     * @callback Sg_Utils~forEachCallback
     * @param {Object} value
     * @param {Integer} indexInArray
     */

    /**
     * A generic iterator function, which can be used to seamlessly iterate over both objects and arrays.
     * Arrays and array-like objects with a length property (such as a function's arguments object) are
     * iterated by numeric index, from 0 to length-1. Other objects are iterated via their named properties.
     *
     * @param {array|object} array - The array/object to iterate over.
     * @param {Sg_Utils~forEachCallback} callback - The function that will be executed on every object.
     */
    forEach: function(array, callback) {
        for (var i = 0, iMax = array.length; i < iMax; i++) {
            callback(array[i], i);
        }
    },

    /**
     * Similar to forEach, but expects a query selector instead of an array.
     *
     * @param {string} selector - A string containing a selector expression.
     * @param {Sg_Utils~forEachCallback} callback - The function that will be executed on every object.
     */
    forEachElement: function (selector, callback) {
        var elements = document.querySelectorAll(selector);
        if(elements) {
            this.forEach(elements, callback);
        }
    },

    /**
     * This callback type is to iterate over addListener function.
     *
     * @callback Sg_Utils~eventCallback
     * @param {Event} event
     */

    /**
     * Attach an event handler function for the passed element.
     *
     * @param {Element} element - A DOM element object.
     * @param {String} type - One event, such as "click".
     * @param {Sg_Utils~eventCallback} callback - Event callback.
     * @param {Boolean} passive - Implement the behaviour with respect to dispatching passive EventListeners so that calling preventDefault inside executing the passive registered callback only generates a warning to the console. Can be used to dramatically improve scrolling performance.
     */
    addListener: function (element, type, callback, passive) {

        var method;

        if (element.addEventListener) {

            method = 1;
            element.addEventListener(type, callback, window.sg_passive && passive ? { passive: true } : false);

        } else if (element.attachEvent) {

            method = 2;
            callback = function () {
                return callback.call(element, window.event);
            };
            element.attachEvent("on" + type, callback);

        } else {
            method = 3;
            element["on" + type] = callback;
        }

        return {
            method: method,
            element: element,
            type: type,
            callback: callback,
            passive: passive
        };
    },

    /**
     * Detach an event created by this.addListener()
     *
     * @param listener - The return response from this.addListener()
     */
    removeListener: function (listener) {

        switch (listener.method) {
            case 1:
                listener.element.removeEventListener(listener.type, listener.callback, window.sg_supportsPassive && listener.passive ? { passive: true } : false);
                break;

            case 2:
                listener.element.detachEvent("on" + listener.type, listener.callback);
                break;

            case 3:
                listener.element["on" + listener.type] = function(){};

        }

    },

    /**
     * Merge the contents of two objects together into the first object.
     *
     * @param {Object} target - The object to extend. It will receive the new properties.
     * @param {Object} object - An object containing additional properties to merge in.
     * @returns {Object}
     */
    extend: function (target, object) {

        var result = {}, property;

        for (property in target) {
            result[property] = target[property];
        }

        for (property in object) {
            if (object[property] && object[property].constructor && object[property].constructor === Object) {
                result[property] = this.extend(target[property] || {}, object[property]);
            } else {
                result[property] = object[property];
            }
        }
        return result;
    },

    /**
     * Determine whether the matched element are assigned the given class.
     *
     * @param {Element} element - A DOM element object.
     * @param {String} className - The class name to search for.
     * @returns {boolean}
     */
    hasClass: function (element, className) {
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(element.className);
    },

    /**
     * Adds the specified class to the element.
     *
     * @param {Element} element - A DOM element object.
     * @param {String} className - One class to be added to the class attribute of the element.
     */
    addClass: function (element, className) {
        if (element.classList) {
            element.classList.add(className);
        } else {
            element.className += ' ' + className;
        }
    },

    /**
     * Add or remove one class from each the element, depending on either the class presence or the value of the state argument.
     *
     * @param {Element} element - A DOM element object.
     * @param {String} className - One class to be added to the class attribute of the element.
     */
    toggleClass: function (element, className) {
        if (this.hasClass(element, className)) {
            this.removeClass(element, className);
        } else {
            this.addClass(element, className);
        }
    },

    /**
     * Remove a single class from the element.
     *
     * @param {Element} element - A DOM element object.
     * @param {String} className - The class name to be removed from the class attribute of the element.
     */
    removeClass: function (element, className) {
        if (element.classList) {
            element.classList.remove(className);
        } else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    },

    /**
     * Detect Mobile Browsers | Source: http://detectmobilebrowsers.com/
     *
     * @returns {boolean}
     */
    userAgentIsMobile: function () {
        var a      = navigator.userAgent || navigator.vendor || window.opera;
        return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)));
    },

    /**
     * Perform an asynchronous HTTP (Ajax) request.
     *
     * @param {String} url - A string containing the URL to which the request is sent.
     * @param {String} method - The HTTP method to use for the request (e.g. "POST", "GET", "PUT")
     * @param {Object} data - Data to be sent to the server.
     * @param {Function} callback - A function to be called when the request finishes
     * @param {Object} xhrFields - An object of fieldName-fieldValue pairs to set on the native XHR object..
     * @returns {XMLHttpRequest}
     */
    request: function (url, method, data, callback, xhrFields) {

        var xhr, finished = false;

        if(typeof callback !== "function") {
            callback = function(){};
        }

        method = typeof method !== "string" ? "GET" : method.toUpperCase();

        var finish = function(data) {

            try {
                if(data.charAt(0) === "{" || data.charAt(0) === "[") {
                    callback(JSON.parse(data));
                    return true;
                }
            } catch (e) {}

            callback(data);
        };

        var dataString = "";
        for (var key in data) {
            if (dataString !== "") {
                dataString += "&";
            }
            dataString += key + "=" + encodeURIComponent(data[key]);
        }

        try {

            if ('XMLHttpRequest' in window) {
                xhr = new XMLHttpRequest();

            } else {

                try {
                    // The latest stable version. It has the best security, performance,
                    // reliability, and W3C conformance. Ships with Vista, and available
                    // with other OS's via downloads and updates.
                    xhr = new ActiveXObject('MSXML2.XMLHTTP.6.0');
                } catch (e) {
                    // The fallback. If this fails will load jQuery to deal with the request
                    xhr = ActiveXObject('MSXML2.XMLHTTP.3.0');
                }

            }

            xhr = Object.assign(xhr, xhrFields);

            if (method === "GET") {
                if(dataString.length>0) {
                    dataString = "?" + dataString;
                }
                xhr.open(method, url + dataString, true);
                dataString = "";

            } else {
                xhr.open(method, url, true);
                if (method !== "POST") {
                    xhr.setRequestHeader("Method", "POST " + url + " HTTP/1.1");
                }
                xhr.setRequestHeader("Content-Type",
                    "application/x-www-form-urlencoded");
            }

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && !finished) {
                    finished = true;
                    finish(xhr.responseText);
                }
            };
            xhr.send(dataString);

        } catch (e) {
            console.error(e);

            Sg_Utils.getScript("//code.jquery.com/jquery-3.3.1.slim.min.js", function(){
                $.ajax({
                    url:        url,
                    method:     method,
                    data:       data,
                    xhrFields:  xhrFields,
                    beforeSend: function( _xhr ) { xhr = _xhr; }
                })
                    .done(finish)
                    .always(function () {
                        finished = true;
                    });
            });
        }

        return xhr;
    },

    /**
     * Sets the value of a cookie. Expiration date and path are optional.
     *
     * @param {String} name - Cookie name
     * @param {String} value - Cookie value
     * @param {Date|Object} options - Expiration Date or Object with optional settings
     * @param {Date} options.expires - Expiration Date
     * @param {String} options.path - Cookie path
     * @param {String} options.domain - Cookie domain
     * @param {Boolean} options.secure - Cookie secure
     */
    setCookie: function(name, value, options) {

        var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

        if (options && options instanceof Date) {
            options = {
                expires: options
            };
        }

        if (options && typeof options === "object") {
            if (options.expires) {
                cookie += '; expires=' + options.expires.toGMTString();
            }
            if (options.path) {
                cookie += '; path=' + options.path.toString();
            }
            if (options.domain) {
                cookie += '; domain=' + options.domain.toString();
            }
            if (options.secure) {
                cookie += '; secure';
            }
        }
        document.cookie= cookie;
    },

    /**
     * Gets the value of a cookie.
     *
     * @param {String} name - cookie name
     * @returns {String}
     */
    getCookie: function(name) {
        var oCrumbles = document.cookie.split(';');
        for(var i=0; i<oCrumbles.length;i++)
        {
            var oPair= oCrumbles[i].split('=');
            var sKey = decodeURIComponent(oPair[0].trim());
            var sValue = oPair.length>1 ? oPair[1] : '';
            if(sKey == name) {
                return decodeURIComponent(sValue);
            }
        }
        return false;
    },

    /**
     * createElement is a convenience wrapper around document.createElement. Since we
     * use createElement all over the place, this allows for (slightly) smaller code
     * as well as abstracting away issues with creating elements in contexts other than
     * HTML documents (e.g. SVG documents).
     *
     * @returns {HTMLElement|SVGElement} An HTML or SVG element
     */
    createElement: function() {
        if (typeof document.createElement !== 'function') {
            // This is the case in IE7, where the type of createElement is "object".
            // For this reason, we cannot call apply() as Object is not a Function.
            return document.createElement(arguments[0]);
        } else if (document.documentElement.nodeName.toLowerCase() === 'svg') {
            return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
        } else {
            return document.createElement.apply(document, arguments);
        }
    },

    /**
     * Detects support for the canvas element for 2D drawing.
     *
     * @returns {boolean}
     */
    supportCanvas: function() {
        var elem = this.createElement('canvas');
        return !!(elem.getContext && elem.getContext('2d'));
    },

    /**
     * Detects support for the text APIs for canvas elements.
     *
     * @returns {boolean}
     */
    supportCanvastext: function() {
        if (this.supportCanvas  === false) {
            return false;
        }
        return typeof this.createElement('canvas').getContext('2d').fillText == 'function';
    },

    /**
     *  Detects support for localstorage.
     *
     *  @returns {boolean}
     */
    supportLocalstorage: function() {
        var mod = 'sg_utils';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * Load a JavaScript file from the server using a GET HTTP request, then execute it.
     *
     * @param {String} src - A string containing the URL to which the request is sent.
     * @param {Function} callback - A callback function that is executed if the request succeeds.
     * @returns {Element}
     */
    getScript: function ( src, callback )
    {
        if(src.charAt(0) === '/' && src.charAt(1) === '/') {
            src = document.location.protocol + src;
        }

        var ref = window.document.getElementsByTagName( "script" )[ 0 ];
        var script = window.document.createElement( "script" );
        script.src = src;
        script.async = true;
        ref.parentNode.insertBefore( script, ref );
        if (callback && typeof(callback) === "function") {
            script.onload = callback;
        }
        return script;
    },


    getStyles: function (id, path) {
        if (!document.getElementById(id)) {
            var head   = document.getElementsByTagName('head')[0],
                link   = document.createElement('link');
            link.id    = id;
            link.rel   = 'stylesheet';
            link.type  = 'text/css';
            link.href  = path;
            link.media = 'all';
            head.appendChild(link);
            return link;
        }
        return false;
    },

    /**
     * Get the ancestors of the element filtered by a selector.
     *
     * @param {Element} elem
     * @param {String} selector - A string containing a selector expression to match elements against.
     * @returns {Element}
     */
    parents: function (elem, selector) {

        var elements = [];
        var ishaveselector = selector !== undefined;

        while ((elem = elem.parentElement) !== null) {
            if (elem.nodeType !== Node.ELEMENT_NODE) {
                continue;
            }

            if (!ishaveselector || elem.matches(selector)) {
                elements.push(elem);
            }
        }

        return elements;
    },

    /**
     * Limit the times per second the method will be handled
     *
     * @param {Function} method
     * @param {Integer} delay - Delay in ms
     */
    debounce: function (func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    /**
     * Get the current coordinates of the element relative to the document.
     *
     * @param {Element} el
     * @returns {{top: number, left: number}}
     */
    getOffset: function( el ) {
        var _x = 0;
        var _y = 0;
        while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
            _x += el.offsetLeft - el.scrollLeft;
            _y += el.offsetTop - el.scrollTop;
            el = el.offsetParent;
        }
        return { top: _y, left: _x };
    },

    /**
     *
     * @returns {{top: number, left: number}}
     */
    getWindowScrollCoordinates: function()
    {
        var _x = 0;
        var _y = 0;

        if(!isNaN( window.pageYOffset )){
            _x = window.pageXOffset;
            _y = window.pageYOffset;
        }
        else{
            var sx, sy, d= document, r= d.documentElement, b= d.body;
            _x= r.scrollLeft || b.scrollLeft || 0;
            _y= r.scrollTop || b.scrollTop || 0;
        }

        return { top: _y, left: _x };
    },

    /**
     * Appends or changes a parameter in the url and returns the new url
     *
     * @param {String} url
     * @param {String} param
     * @param {String} value
     * @returns {String}
     */
    urlAddParam: function (url, param, value) {
        var hash   = {},
            parser = document.createElement('a');

        parser.href = url;

        var parameters = parser.search.split(/[?&]/);

        for (var i = 0; i < parameters.length; i++) {
            if (!parameters[i]) continue;
            var ary      = parameters[i].split('=');
            hash[ary[0]] = ary[1];
        }

        hash[param] = value;

        var list = [];
        Object.keys(hash).forEach(function (key) {
            list.push(key + '=' + hash[key]);
        });

        parser.search = '?' + list.join('&');
        return parser.href;
    },

    fadeOut: function (element) {
        element.style.opacity = 1;

        (function fade() {
            if ((element.style.opacity -= 0.1) < 0) {
                element.style.visibility = "hidden";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    },

    fadeIn: function (element, visibility) {
        element.style.opacity = 0;
        element.style.visibility = visibility || "";

        (function fade() {
            var val = parseFloat(element.style.opacity);
            if ((val += 0.1) <= 1) {
                element.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    },

    onReadyStateComplete: function(callback) {

        if(document.readyState === "complete") {
            callback();
            return;
        }

        Sg_Utils.addListener(document, "readystatechange", function (event) {
            if(event.target.readyState === "complete") {
                callback();
            }
        });

    }

};
window.Sg_Utils = Sg_Utils;

export default Sg_Utils;